import create from './createAction'

export const UPDATE_VOUCHER_DATA = 'UPDATE_VOUCHER_DATA'
export const REMOVE_VOUCHER_DATA = 'REMOVE_VOUCHER_DATA'
export const VALIDATE_BEFORE_PAYMENT = 'VALIDATE_BEFORE_PAYMENT'
export const VALIDATE_VOUCHER = 'VALIDATE_VOUCHER'
export const VALIDATE_SUCCEEDED = 'VALIDATE_SUCCEEDED'
export const VALIDATE_FAILED = 'VALIDATE_FAILED'
export const RESET_VOUCHER = 'RESET_VOUCHER'
export const VALIDATE_BEFORE_PROCEED = 'VALIDATE_BEFORE_PROCEED'
export const REDEEM_VOUCHERS = 'REDEEM_VOUCHERS'
export const INIT_SESSION = 'INIT_SESSION'
export const UPDATE_VOUCHER_SESSION = 'UPDATE_VOUCHER_SESSION'
export const VALIDATE_VOUCHER_SESSION = 'VALIDATE_VOUCHER_SESSION'
export const REMOVE_VOUCHER = 'REMOVE_VOUCHER'

export const redeemVouchers = create(REDEEM_VOUCHERS)

export const validateVoucherBeforeProceed = create(VALIDATE_BEFORE_PROCEED)

export const resetVoucher = create(RESET_VOUCHER)

export const updateVoucherData = create(UPDATE_VOUCHER_DATA)

export const removeVoucher = create(REMOVE_VOUCHER)

export const removeVoucherData = create(REMOVE_VOUCHER_DATA)

export const validateVoucher = create(VALIDATE_VOUCHER)

export const validateSucceeded = create(VALIDATE_SUCCEEDED)

export const validateFailed = create(VALIDATE_FAILED)

export const initSession = create(INIT_SESSION)

export const updateVoucherSession = create(UPDATE_VOUCHER_SESSION)

export const validateVoucherSession = create(VALIDATE_VOUCHER_SESSION)
